import { type KpiCard, kpiCards, todayTasks, overdueTasks, todayPayment, formatMoney } from "@/mocks/managerWorkspace";

export default function KpiCards() {
  const totalCards = kpiCards.length + 2; // tasks + 5 kpi + payments

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:flex lg:flex-nowrap gap-3">
      {/* Tasks card — special: shows count + overdue in red */}
      <div className="flex items-center gap-2.5 p-3 bg-white rounded-lg border border-[#D5CA8A] hover:shadow-md transition-shadow lg:flex-1 lg:min-w-0">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-[#D4EDDA]">
          <i className="ri-task-line text-[16px] text-[#2D6A4F]"></i>
        </div>
        <div>
          <p className="text-[10px] text-[#666666] leading-tight">Задачи на сегодня</p>
          <div className="flex items-baseline gap-1.5 mt-0.5">
            <p className="text-[18px] font-bold text-[#2D2D2D] leading-tight">{todayTasks}</p>
            <span className="text-[11px] font-semibold text-[#DC2626] leading-tight">
              +{overdueTasks} просрочено
            </span>
          </div>
        </div>
      </div>

      {/* Regular KPI cards (5) */}
      {kpiCards.map((card: KpiCard) => (
        <div
          key={card.label}
          className="flex items-center gap-2.5 p-3 bg-white rounded-lg border border-[#D5CA8A] hover:shadow-md transition-shadow lg:flex-1 lg:min-w-0"
        >
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${card.iconBg}`}>
            <i className={`${card.icon} text-[16px] ${card.color}`}></i>
          </div>
          <div>
            <p className="text-[10px] text-[#666666] leading-tight">{card.label}</p>
            <p className="text-[18px] font-bold text-[#2D2D2D] leading-tight mt-0.5">{card.value}</p>
          </div>
        </div>
      ))}

      {/* Payments card */}
      <div className="flex items-center gap-2.5 p-3 bg-white rounded-lg border border-[#D5CA8A] hover:shadow-md transition-shadow lg:flex-1 lg:min-w-0">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-[#D4EDDA]">
          <i className="ri-check-double-line text-[16px] text-[#2D6A4F]"></i>
        </div>
        <div>
          <p className="text-[10px] text-[#666666] leading-tight">Оплаты сегодня</p>
          <p className="text-[18px] font-bold text-[#2D6A4F] leading-tight mt-0.5">{formatMoney(todayPayment)}</p>
        </div>
      </div>
    </div>
  );
}